import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  applyPreset: {
    defaultMessage: 'Apply Preset',
    description: 'orderDrawer.applyPreset.applyPreset',
    id: 'TBj+g8',
  },
  presetLabel: {
    defaultMessage: 'Preset',
    description: 'orderDrawer.applyPreset.presetLabel',
    id: '31Nggz',
  },
  containsFedexHalSelection: {
    defaultMessage: 'One of the selected order is HAL order. Applying preset is not supported for HAL orders.',
    description: 'orderDrawer.applyPreset.containsFedexHalSelection',
    id: 'XeSRZj',
  },
  managePresets: {
    description: 'presets.managePresets',
    defaultMessage: 'Manage Presets',
    id: 'yDQTww',
  },
});
